module.exports = new __parcel__URL__("Frame-5.be899fe1.svg").toString();